import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_STATES_REQUEST, fetchStatesSuccess, fetchStatesFailure,
  CREATE_STATE_REQUEST, createStateSuccess, createStateFailure,
  UPDATE_STATE_REQUEST, updateStateSuccess, updateStateFailure,
  DELETE_STATE_REQUEST, deleteStateSuccess, deleteStateFailure
} from '../actions/stateActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const token = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');

const createConfig = () => ({
  headers: { 'Authorization': `Bearer ${authToken}` }
});

function* fetchStates(action) {
  try {
    const token = getAuthToken();
    const { projectId, page = 1, limit = 1, search = '', group = '' } = action.payload || {};
    
    console.log("Fetching phy with payload: ", action.payload);

    const response = yield call(
      axios.get,
      `${getBaseUrl()}/${projectId}/state`, // Updated endpoint
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );

    // Expecting `data` and `meta` in the response
    yield put(fetchStatesSuccess(response.data));
  } catch (error) {
    console.error("Error fetching State: ", error);
    yield put(fetchStatesFailure(error.response?.data?.message || error.message));
  }
}

function* createState(action) {
  try {
    const { id, ...data } = action.payload;
    const projectID = id;
    console.log("state saga ",data,id)
    const response = yield call(axios.post, `${API_BASE_URL}/${projectID}/state`, data, createConfig());
    yield put(createStateSuccess(response.data));
  } catch (error) {
    yield put(createStateFailure(error.message));
  }
}

function* updateState(action) {
  try {
    const { id, data,projectId } = action.payload;
    delete data.id;
    console.log("state saga update ", data, id,projectId)
    const response = yield call(axios.put, `${API_BASE_URL}/${projectId}/state/${id}`, data, createConfig());
    yield put(updateStateSuccess(response.data));
  } catch (error) {
    yield put(updateStateFailure(error.message));
  }
}

function* deleteState(action) {
  try {
    const { id, projectId } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/${projectId}/state/${id}`, createConfig());
    yield put(deleteStateSuccess(id));
  } catch (error) {
    yield put(deleteStateFailure(error.message));
  }
}

export default function* stateSaga() {
  yield takeLatest(FETCH_STATES_REQUEST, fetchStates);
  yield takeLatest(CREATE_STATE_REQUEST, createState);
  yield takeLatest(UPDATE_STATE_REQUEST, updateState);
  yield takeLatest(DELETE_STATE_REQUEST, deleteState);
}
